import React from 'react';

const Hero = () => {
  const scrollToProducts = () => {
    const element = document.getElementById('products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#F5F1EB]">
      {/* Background Image - Smaller with border radius */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat rounded-3xl mx-8 my-16"
        style={{
          backgroundImage: `url('/clock-with-lamp-it-that-says-word-it.jpg')`,
        }}
      >

      </div>

      {/* Top Button - Left Corner */}
      <div className="absolute top-12 left-5 z-10">
        <button 
          onClick={scrollToProducts}
          className="bg-[#F5F1EB] text-black px-8 py-4 roundedbtn hover:bg-opacity-90 transition-all duration-300 font-medium text-lg flex items-center justify-between min-w-[200px]"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span className="font-semibold">Find a spare</span>
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      {/* Bottom Button - Right Corner */}
      <div className="absolute bottom-12 right-5 z-10">
        <button 
          onClick={scrollToProducts}
          className="bg-[#F5F1EB] text-black px-8 py-4 roundedbtn hover:bg-opacity-90 transition-all duration-300 font-medium text-lg flex items-center justify-between min-w-[200px]"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span className="font-semibold">Find a spare</span>
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </section>
  );
};

export default Hero;
